import { Component, Input, OnInit } from '@angular/core';
import { ActivitiesService } from '../../../services/activities.service';
import { TypesService } from '../../../services/types.service';

@Component({
  selector: 'app-activities-preview',
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.css'
})
export class ActivitiesPreviewComponent implements OnInit {
  @Input()
  id:any=0;
  @Input()
  record:any;

  types:any=[];


  constructor(private activitiesService:ActivitiesService,private typesService:TypesService){}
  ngOnInit(): void {

    this.typesService.getTypes("activities").subscribe((result)=>{
      this.types=result;
    });

    if(this.id>0){
      this.activitiesService.getItem(this.id,true).subscribe((result)=>{
        this.record=result;
      })
    }
  }


  searchType(id){
    for(let t of this.types){
      if(t.id==id){
        return t;
      }
    }
  }


  close(){
    this['modalWindow'].close();
  }
} 
